module.exports = __webpack_public_path__ + "media/bootstrap-icons/watch-c8f86633.svg";